import type { Location } from 'modules/core/lib/navigation/types'

export const expensesNavigation = {
  path: 'expenses',
  size: 'full',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        expenses: {
          path: 'expenses',
          size: 'full',
          children: {
            expenseId: {
              path: ':expense_id',
              size: 'full',
            },
            exporter: {
              path: 'exporter',
              size: 'full',
            },
          },
        },
        groups: {
          path: 'groups',
          size: 'full',
        },
      },
    },
    groups: {
      path: 'groups',
      size: 'full',
      children: {
        id: {
          path: ':groupId',
          size: 'full',
          children: {
            edit: {
              path: 'edit',
              size: 'full',
            },
            expenseId: {
              path: ':expense_id',
              size: 'full',
            },
          },
        },
      },
    },
    new_card: {
      path: 'new-card',
      size: 'full',
    },
    reports: {
      path: 'reports',
      size: 'full',
    },
    budgets: {
      path: 'budgets',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            new: {
              path: 'new',
              level: 2,
            },
          },
        },
        detail: {
          path: ':budgetId',
          level: 2,
          children: {
            records: {
              path: 'records',
              level: 2,
            },
            employees: {
              path: 'employees',
              level: 2,
            },
          },
        },
        // TODO: replace with detail when revamp is ready for all budget types
        detailRevamp: {
          path: 'revamp/:budgetId',
          level: 2,
        },
      },
    },
    spendingPolicies: {
      path: 'spending-policies',
      size: 'full',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            new: {
              path: 'new',
              level: 2,
            },
          },
        },
        detail: {
          path: ':policyId',
          level: 2,
        },
      },
    },
  },
} as const satisfies Location
